// @flow

import _ from 'lodash/fp';

const shouldUseOrderRowPrice = (
  variant: any,
  slot: any,
  row: ?any,
  variantConfig: ?any,
  config: ?any,
): boolean =>
  !!row &&
  (slot.advanced && !!config && !!variantConfig
    ? row.configId === variantConfig.id
    : row.productVariantId === variant.id
  ) &&
  row.productSlotId === slot.id &&
  !_.isNil(row.orderedPrice) &&
  !_.isNil(row.orderedQuantity);

export const productPrice = (
  variant: any,
  slot: any,
  row: ?any,
  variantConfig: ?any,
  config: ?any,
): number =>
  shouldUseOrderRowPrice(variant, slot, row, variantConfig, config) && !!row
    ? row.orderedPrice * row.orderedQuantity
    : (
      !!variantConfig && variantConfig.customPrice !== null
        ? variantConfig.customPrice
        : variant.sellingPrice
    ) * (
      !!variantConfig
        ? variantConfig.quantity
        : slot.quantity
    );

const formatUnit = (quantity, unit): string =>
  quantity === 1
    ? unit
    : _.isEmpty(unit)
      ? quantity
      : `${quantity} ${unit}`;

export const productUnit = (
  variant: any,
  slot: any,
  row: ?any,
  variantConfig: ?any,
  config: ?any,
): string =>
  shouldUseOrderRowPrice(variant, slot, row, variantConfig, config) && !!row
    ? formatUnit(row.orderedQuantity, row.ordererdUnit)
    : !!variantConfig
      ? formatUnit(variantConfig.quantity, variantConfig.unit)
      : formatUnit(slot.quantity, slot.unit);

export const sumRow = (order: any) => (row: any): number =>
  row.orderedPrice === null
    ? row.price * row.quantity
    : row.orderedPrice * row.orderedQuantity;

export const sumExtraRow = (order: any) => (row: any): number =>
  row.orderedPrice === null
    ? row.price * row.quantity
    : row.orderedPrice * row.quantity;

export const totalPrice = (order: any): number =>
  _.flow(
    _.add(_.sumBy(sumRow(order), order.rows)),
    _.add(_.sumBy(sumExtraRow(order), order.extraRows)),
    _.add(_.sumBy(r => r.totalSellingPrice, order.customRows)),
    _.add(-order.discount),
    _.clamp(0, Infinity),
    _.round
  )(0);

// Transform value to add VAT or remove VAT with guarantee of MAX two decimals
export const removeVAT = (val: number): number => Math.round(val * 80) / 100;
export const addVAT = (val: number): number => Math.round(val * 125) / 100;



// WEBPACK FOOTER //
// ./src/helpers/priceHelpers.js